export class IPayDetails {
   _id: string;
   invoice: string;
   salary:number;
   trainerShare: number;
   totalPaid: number;
   month: number;
   day: number;
   year: number;
   date: Date;
   description: string;
}


